import Vue from 'vue';
import Glide from 'vue-glide';

import App from './App';
import BaseSvg from './components/BaseSvg';
import BaseImage from './components/BaseImage';
import BaseBlade from './components/BaseBlade';
import BaseArrow from './components/BaseArrow';
import BaseInvisible from './components/BaseInvisible';
import TransitionSlide from './components/TransitionSlide';

Vue.config.productionTip = false;

Vue.use(Glide);

Vue.component('BaseSvg', BaseSvg);
Vue.component('BaseImage', BaseImage);
Vue.component('BaseBlade', BaseBlade);
Vue.component('BaseArrow', BaseArrow);
Vue.component('BaseInvisible', BaseInvisible);
Vue.component('TransitionSlide', TransitionSlide);

// eslint-disable-next-line no-new
new Vue(App);
